import React from "react";

export const Head = () => (
  <>
    <html lang="en-US" />
    <title>Passkeys.directory</title>
    <meta
      name="description"
      content="A community-driven index of websites, apps, and services that offer signing in with passkeys."
    />
    <meta name="author" content="1Password" />
    <meta property="og:updated_time" content="1686155243" />
    <meta name="theme-color" content="#fff" />
    <link rel="canonical" />

    <meta property="og:locale" content="en_US" />
    <meta property="og:site_name" content="Passkeys.directory" />
    <meta property="og:title" content="Passkeys.directory" />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://passkeys.directory" />
    <meta
      property="og:description"
      content="A community-driven index of websites, apps, and services that offer signing in with passkeys."
    />
    <meta
      property="og:image"
      itemProp="image"
      content="https://passkeys.directory/images/passkey-dir-ogimage.png"
    />
    <meta
      property="og:image:secure_url"
      content="https://passkeys.directory/images/passkey-dir-ogimage.png"
    />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />

    <meta
      name="twitter:image"
      property="og:image"
      content="https://passkeys.directory/images/passkey-dir-ogimage.png"
    />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@1Password" />
    <meta name="twitter:title" content="Passkeys.directory" />
    <meta
      name="twitter:description"
      content="A community-driven index of websites, apps, and services that offer signing in with passkeys."
    />
    <meta property="twitter:url" content="https://passkeys.directory" />

    <link
      rel="apple-touch-icon"
      sizes="180x180"
      href="https://passkeys.directory/images/apple-touch-icon.png"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="32x32"
      href="https://passkeys.directory/images/favicon-32x32.png"
    />
    <link
      rel="icon"
      type="image/png"
      sizes="16x16"
      href="https://passkeys.directory/images/favicon-16x16.png"
    />
    <link rel="mask-icon" href="https://passkeys.directory/images/pinned-tab.svg" color="black" />
  </>
);
